import { ActionReducerMap } from '@ngrx/store'
import { appReducer } from './app.reducer'

export interface AppState {
  app: any
}

export const reducers: ActionReducerMap<AppState> = {
  app: appReducer
}
